// extracted by mini-css-extract-plugin
export default {"CheckBox":"CheckBox_CheckBox__WgXzo","checkBoxLabel":"CheckBox_checkBoxLabel__n3d0a","CheckBoxError":"CheckBox_CheckBoxError__ZXXJ3","ErrorMessage":"CheckBox_ErrorMessage__VVzPj"};